import { schemaPatientForPrescriptionForm } from 'services/user-patient-profile';
export const schemaPatientForm = schemaPatientForPrescriptionForm;
